import {Component} from "@angular/core";

@Component({
    selector: "fui-content-layout-header-control",
    styleUrls: ["./content-layout-header-control.component.scss"],
    templateUrl: "./content-layout-header-control.component.html"
})
export class FUIContentLayoutHeaderControlComponent {
}
